import 'bulma/css/bulma.css'
import '@mdi/font/css/materialdesignicons.css'

import { createApp } from 'vue'
import App from './App.vue'
import router from './routes'

const app = createApp(App);
app.use(router).mount('#app')
